import { createMultipleEntities, createSingleEntities } from '@ps/web-shared-analytics';
import { useSelector } from 'react-redux';

import { getAvailableSingleOpportunities } from '@swf/core/models/sports/utils/betSlip/getAvailableOpportunities';
import { select } from '@swf/core/store';

const useCreateEntities = () => {
  const opportunities = useSelector(select.betSlip.singleOpportunities);

  return {
    createSingleEntities,
    createMultipleEntities: createMultipleEntities(getAvailableSingleOpportunities(opportunities))
  };
};

export default useCreateEntities;
